import { render } from "./BrandParentValue.vue?vue&type=template&id=3280a95f"
import script from "./BrandParentValue.vue?vue&type=script&lang=js"
export * from "./BrandParentValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__